export enum LocalStorageKeys {
    VisitedOffers = 'visitedOffers',
}